import type { SxProps, Theme } from '@portals/core/src/themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    container: {
      cursor: 'pointer',
      lineHeight: 1,

      '&, .if6 &': {
        textDecoration: 'none',
        pointerEvents: 'auto',
      },
    },
    text: {
      alignSelf: 'center',
      color: theme.palette.text.primary,
    },
  };
};
